'use client';
import { memo } from 'react';
import buildLinkObj, { getRel } from '@repo/ui/src/functions/build-link';
import { ModalID, useModal } from '@repo/ui/src/modules/UI';
import StoriesGridItemContent from './_StoriesGridItemContent';
import { StoryItemContainer } from './styles';

const StoriesGridItem = ({ item }) => {
  const { push } = useModal(ModalID.video);
  const { youtubeLink, index, _meta } = item || {};
  const linkObj = _meta?.deliveryKey ? buildLinkObj({ link: _meta?.deliveryKey }) : null;

  const content = <StoriesGridItemContent {...item} linkObj={linkObj} />;

  if (linkObj) {
    return (
      <StoryItemContainer component="a" rel={getRel(linkObj)} href={linkObj?.href}>
        {content}
      </StoryItemContainer>
    );
  }
  if (youtubeLink) {
    return (
      <StoryItemContainer
        role="button"
        tabIndex={index}
        onClick={() => push({ youtubeLink, playlistItems: youtubeLink?.associatedPlaylist?.body })}
        onKeyDown={() =>
          push({ youtubeLink, playlistItems: youtubeLink?.associatedPlaylist?.body })
        }
      >
        {content}
      </StoryItemContainer>
    );
  }
  return <StoryItemContainer>{content}</StoryItemContainer>;
};

export default memo(StoriesGridItem);
